<template>
  <div class="my-service">
    <ul class="service-list">
      <li class="service-item" @click="entoAmount">
        <div class="left"><i class="iconfont icon-lingjuanweidianji"></i><span>待返金额</span></div>
        <div class="right">
          <span class="price">￥{{ userInfo.SaleAmountBack | formatFloat }}</span
          ><van-icon name="arrow" class="arrowIcon" />
        </div>
      </li>
      <li class="service-item" @click="balanceWithDraw">
        <div class="left"><i class="iconfont icon-qianbao"></i><span>余额提现</span></div>
        <div class="right">
          <span class="price">￥{{ userInfo.Amount | formatFloat }}</span
          ><van-icon name="arrow" class="arrowIcon" />
        </div>
      </li>
      <li class="service-item" @click="shareClick">
        <div class="left">
          <i class="iconfont icon-yaoqing2"></i><span>邀请好友</span><span class="card">免单卡+{{ recommendCards || 0 }}</span>
        </div>
        <div class="right">
          <van-icon name="arrow" class="arrowIcon" />
        </div>
      </li>
      <li class="service-item" @click="recommendRank" v-if="isShowRank">
        <div class="left">
          <i class="iconfont icon-paihang"></i><span>推荐排行</span><span class="card">免单卡+{{ rankFreeCarts || 0 }}</span>
        </div>
        <div class="right">
          <van-icon name="arrow" class="arrowIcon" />
        </div>
      </li>
      <li class="line"></li>
      <li class="service-item" @click="violationPage">
        <div class="left">
          <i class="iconfont icon-time"></i><span>待办与违规</span>
          <van-tag round color="#f44336" type="primary" class="numTag" v-if="waitDoneRecordCountAddUnReadCount">+{{ waitDoneRecordCountAddUnReadCount }}</van-tag>
        </div>
        <div class="right">
          <van-icon name="arrow" class="arrowIcon" />
        </div>
      </li>
      <li class="line"></li>
      <!-- <li class="service-item" @click="platformProtocol">
        <div class="left">
          <i class="iconfont icon-xieyi"></i><span>平台协议</span>
        </div>
        <div class="right">
          <van-icon name="arrow" class="arrowIcon" />
        </div>
      </li> -->
      <!-- <li class="service-item" @click="rebateNote">
        <div class="left">
          <i class="iconfont icon-tubiao-"></i><span>返利说明</span>
        </div>
        <div class="right">
          <van-icon name="arrow" class="arrowIcon" />
        </div>
      </li>       -->
      <!-- <li class="service-item" @click="contactCs">
        <div class="left">
          <i class="iconfont icon-kefu1"></i><span>联系客服</span>
        </div>
        <div class="right">
          <van-icon name="arrow" class="arrowIcon" />
        </div>
      </li>
      <li class="service-item" @click="makeComplaints">
        <div class="left">
          <i class="iconfont icon-tucaofankui"></i><span>吐槽反馈</span>
        </div>
        <div class="right">
          <van-icon name="arrow" class="arrowIcon" />
        </div>
      </li> -->
      <li v-if="getIsApp" class="service-item" @click="enterRemindSetting">
        <div class="left"><i class="iconfont icon-tongzhi"></i><span>推送设置</span></div>
        <div class="right">
          <span class="arrowIcon">{{ notificationAuthorized ? '已开启' : '已关闭' }}</span>
          <van-icon name="arrow" class="arrowIcon" />
        </div>
      </li>
      <li v-if="!getIsApp" class="service-item" @click="enterUserInfo">
        <div class="left"><i class="iconfont icon-gerenzhiyeguihua"></i><span>个人信息</span></div>
        <div class="right">
          <van-icon name="arrow" class="arrowIcon" />
        </div>
      </li>
      <li class="service-item" @click="aboutUs">
        <div class="left"><i class="iconfont icon-warn"></i><span>关于我们</span></div>
        <div class="right">
          <van-icon name="arrow" class="arrowIcon" />
        </div>
      </li>
      <li class="service-item" @click="helpAndFeedback">
        <div class="left"><i class="iconfont icon-lianxikefu-copy"></i><span>帮助与反馈</span></div>
        <div class="right">
          <van-icon name="arrow" class="arrowIcon" />
        </div>
      </li>
      <li v-if="getIsApp" class="service-item" @click="enterUserInfo">
        <div class="left"><i class="iconfont icon-gerenzhiyeguihua"></i><span>账号和安全</span></div>
        <div class="right">
          <van-icon name="arrow" class="arrowIcon" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Tag, Icon } from 'vant'
export default {
  components: {
    'van-tag': Tag,
    'van-icon': Icon
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['getIsApp', 'notificationAuthorized']),
    waitDoneRecordCountAddUnReadCount() {
      return this.userInfo.WaitDoneRecordCount + this.userInfo.UnReadCount
    }
  },
  props: {
    // 邀请好友免单卡数
    recommendCards: {
      type: [Number, String],
      default: 0
    },
    // 是否显示推荐排行
    isShowRank: {
      type: Boolean,
      default: false
    },
    // 推荐排汗免单卡数
    rankFreeCarts: {
      type: [Number, String],
      default: 0
    },
    userInfo: {
      type: Object,
      require: true,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    entoAmount() {
      this.$emit('entoAmount')
    },
    balanceWithDraw() {
      this.$emit('balanceWithDraw')
    },
    shareClick() {
      this.$emit('shareClick')
    },
    recommendRank() {
      this.$emit('recommendRank')
    },
    platformProtocol() {
      this.$emit('platformProtocol')
    },
    rebateNote() {
      this.$emit('rebateNote')
    },
    waitHandler() {
      this.$emit('waitHandler')
    },
    violationPage() {
      this.$emit('violationPage')
    },
    contactCs() {
      this.$emit('contactCs')
    },
    makeComplaints() {
      this.$emit('makeComplaints')
    },
    aboutUs() {
      this.$emit('aboutUs')
    },
    enterUserInfo() {
      this.$emit('enterUserInfo')
    },
    enterRemindSetting() {
      this.$emit('enterRemindSetting')
    },
    helpAndFeedback() {
      this.$emit('helpAndFeedback')
    }
  },
  filters: {
    formatFloat(val) {
      if (!val) {
        val = 0
      }
      return Number(val).toFixed(2)
    }
  }
}
</script>

<style scoped lang="scss">
.my-service {
  margin-top: 2.2%;
  background: #ffffff;
}
.service-list {
  padding: 10px 15px;
  box-sizing: border-box;
}
.service-list .line {
  width: 100%;
  height: 1px;
  background: #f2f2f2;
  margin: 5px 0;
}
.service-item {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
}
.service-item:active {
  background: #f2f2f2;
}
.service-item .left {
  display: flex;
  align-items: center;
  font-size: 15px;
  .numTag {
    margin-left: 5px;
  }
}
.service-item .left .iconfont {
  font-size: 20px;
  margin-right: 15px;
  vertical-align: middle;
}
.service-item .left .icon-tucaofankui {
  font-size: 16px;
  margin-right: 17px;
  margin-left: 2px;
}
.service-item .left .icon-koufen-copy-copy {
  position: relative;
  top: 0px;
  margin-left: -0.5px;
  font-size: 19px;
}
.service-item .left .icon-time {
  position: relative;
  top: -1px;
  left: 2px;
  font-size: 17px;
  margin-right: 17px;
}
.service-item .left .icon-warn,
.service-item .left .icon-tuichu {
  font-size: 17px;
  margin-right: 17px;
  position: relative;
  left: 1px;
}
.service-item .right {
  display: flex;
  align-items: center;
  position: relative;
  font-size: 15px;
}
.service-item .price {
  margin-right: 4px;
  margin-bottom: 1px;
}
.service-item .arrowIcon {
  color: #888888;
}
.service-item .icon {
  position: relative;
}
.service-item .icon::after {
  content: ' ';
  border: solid 2px #c8c8cd;
  border-bottom-width: 0;
  border-left-width: 0;
  top: 50%;
  right: 4px;
  position: absolute;
  width: 5px;
  height: 5px;
  transform: translateY(-50%) rotate(45deg);
}
.service-item .card {
  display: inline-block;
  background: #faeddd;
  color: #d8b46e;
  border-radius: 10px;
  padding: 1px 8px;
  vertical-align: middle;
  margin-left: 5px;
  font-size: 12px;
}
</style>
